var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBbiresolvelogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-4 {\n        fill: #000;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-6);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 388.05,
    y1: 221.58,
    x2: 488.23,
    y2: 221.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0255bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0457c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#1873cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#2687d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2f93d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3297db"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 355.32,
    y1: 347.89,
    x2: 449.8,
    y2: 347.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 273.43,
    y1: 423.36,
    x2: 355.33,
    y2: 423.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 159.32,
    y1: 432.07,
    x2: 233.21,
    y2: 432.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 67.06,
    y1: 376.94,
    x2: 125.71,
    y2: 376.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 11.77,
    y1: 272.43,
    x2: 66.39,
    y2: 272.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 28.26,
    y1: 160.58,
    x2: 72.43,
    y2: 160.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 105.86,
    y1: 72.66,
    x2: 146.53,
    y2: 72.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 223.39,
    y1: 36.88,
    x2: 254.3,
    y2: 36.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 343.09,
    y1: 70.95,
    x2: 362.28,
    y2: 70.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 401.62,
    y1: 119.18,
    x2: 412.52,
    y2: 119.18,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262.13,309.27l-35.31-61.35h-19.2v61.35h-25.16v-153.38h52.96c11.77,0,21.74,2.06,29.9,6.18,8.17,4.12,14.27,9.64,18.32,16.55,4.04,6.92,6.07,14.64,6.07,23.17,0,10.01-2.91,19.09-8.72,27.25-5.81,8.17-14.75,13.72-26.81,16.66l37.96,63.56h-30.01ZM207.62,227.84h27.81c9.41,0,16.51-2.35,21.3-7.06,4.78-4.71,7.17-11.03,7.17-18.98s-2.35-14.16-7.06-18.65c-4.71-4.49-11.85-6.73-21.41-6.73h-27.81v51.42Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 438.14,
    cy: 221.58,
    r: 50.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 402.56,
    cy: 347.89,
    r: 47.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 314.38,
    cy: 423.36,
    r: 40.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 196.26,
    cy: 432.07,
    r: 36.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 96.39,
    cy: 376.94,
    r: 29.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 39.08,
    cy: 272.43,
    r: 27.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 50.34,
    cy: 160.58,
    r: 22.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 126.2,
    cy: 72.66,
    r: 20.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 238.84,
    cy: 36.88,
    r: 15.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 352.69,
    cy: 70.95,
    r: 9.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 407.07,
    cy: 119.18,
    r: 5.45
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbiresolvelogo);
export default __webpack_public_path__ + "static/media/bbiresolvelogo.72b96ff18c6182353e1d563089b527a5.svg";
export { ForwardRef as ReactComponent };